import React, { useEffect, useState } from "react";
import { Leaf } from "lucide-react";
import { Logo } from "@/components/Logo";

const IDLE_MS = 60000;
const LINES = [
  "Schermo nero, meno consumi: anche così siamo green.",
  "Mentre sei via, risparmiamo energia per te.",
  "Pixel spenti = watt risparmiati.",
  "Pensiamo green, anche quando nessuno guarda.",
];
const EVENTS = ["pointermove", "pointerdown", "keydown", "touchstart", "wheel", "scroll"];

export const GreenStandby = () => {
  const [idle, setIdle] = useState(false);
  const [line, setLine] = useState(0);
  useEffect(() => {
    let t;
    const reset = () => { setIdle(false); clearTimeout(t); t = setTimeout(() => setIdle(true), IDLE_MS); };
    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => { clearTimeout(t); EVENTS.forEach((e) => window.removeEventListener(e, reset)); };
  }, []);
  useEffect(() => {
    if (!idle) return undefined;
    const i = setInterval(() => setLine((n) => (n + 1) % LINES.length), 6000);
    return () => { clearInterval(i); };
  }, [idle]);
  if (!idle) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-black flex flex-col items-center justify-center gap-8 px-6 text-center animate-in fade-in duration-700 cursor-none" data-testid="green-standby">
      <div className="[&_*]:!text-white"><Logo size={64} wander /></div>
      <p key={line} className="flex items-center gap-2 text-emerald-400 text-base sm:text-lg animate-in fade-in slide-in-from-bottom-2 duration-700" data-testid="green-standby-line"><Leaf className="w-5 h-5 shrink-0" />{LINES[line]}</p>
      <p className="text-xs text-white/40">Tocca lo schermo o muovi il mouse per riprendere</p>
    </div>
  );
};
